module.exports = __webpack_public_path__ + "img/section_land_buildings.653ffac0.png";